import { Routes, Route } from "react-router-dom";
import Books from "./pages/Books";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Cart from "./pages/Cart";
// import Orders from "./pages/Orders";
import ProtectedRoute from "./components/ProtectedRoute";
import "./styles/App.css";
import About from "./pages/About";
import SingleBook from "./pages/SingleBook";
import User from "./pages/User";
import ScrollToTop from "./components/ScrollToTop";
import Contact from "./pages/Contact";
import GlobalChat from "./pages/GlobalChat";
import Checkout from "./pages/Checkout";
import ShippingAddess from "./pages/ShippingAddess";
import Payment from "./pages/Payment";
import Orders from "./pages/Orders";
import SingleOrder from "./pages/SingleOrder";

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<About />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        <Route path="/books" element={<Books />} />
        <Route path="/books/:_id" element={<SingleBook />} />

        <Route
          path="/cart"
          element={
            <ProtectedRoute>
              <Cart />
            </ProtectedRoute>
          }
        />

        <Route
          path="/checkout/address"
          element={
            <ProtectedRoute>
              <ShippingAddess />
            </ProtectedRoute>
          }
        />

        <Route
          path="/checkout/review"
          element={
            <ProtectedRoute>
              <Checkout />
            </ProtectedRoute>
          }
        />

        <Route
          path="/checkout/payment"
          element={
            <ProtectedRoute>
              <Payment />
            </ProtectedRoute>
          }
        />

        <Route
          path="/orders"
          element={
            <ProtectedRoute>
              <Orders />
            </ProtectedRoute>
          }
        />
        <Route
          path="/orders/:orderId"
          element={
            <ProtectedRoute>
              <SingleOrder />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/user"
          element={
            <ProtectedRoute>
              <User />
            </ProtectedRoute>
          }
        />
        <Route
          path="/global"
          element={
            <ProtectedRoute>
              <GlobalChat />
            </ProtectedRoute>
          }
        />
        <Route
          path="/contact"
          element={
            <ProtectedRoute>
              <Contact />
            </ProtectedRoute>
          }
        />

        <Route path="/*" element={<About />} />
      </Routes>
    </>
  );
}

export default App;
